import React from 'react'
import PropTypes from 'prop-types'
import Paginated from 'meteor-paginated-graphql-react'
import Loading from 'orionsoft-parts/lib/components/Loading'
import styles from './styles.css'
import { withRouter } from 'react-router'
import TiGroupOutline from 'react-icons/lib/ti/group-outline'
import moment from 'moment'
import autobind from 'autobind-decorator'
import isAdmin from '../../../Decorators/isAdmin'

@isAdmin
@withRouter
export default class OrganizationsData extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    admin: PropTypes.string
  }

  @autobind
  onSelect({ _id }) {
    this.props.router.push(`/admin/organizationsdata/${_id}`)
  }

  getFields() {
    return [
      { title: '', name: '_id', render: () => <TiGroupOutline size={20} /> },
      {
        title: 'Nombre',
        name: 'name'
      },
      {
        title: 'CreatedAt',
        name: 'createdAt',
        render: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm')
      }
    ]
  }

  render() {
    if (this.props.admin !== 'admin'){
      console.log('Route /Admin/OrgData');
      return this.props.router.push('/')
    } 
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              queryName="allOrganizations"
              fields={this.getFields()}
              ref="paginated"
              params="$filter: String"
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/OrganizationsData/index.js